import Home01 from './Home01';
import Home02 from './Home02';
import Home03 from './Home03';
import Home04 from './Home04';

const routes = [
    { path: "/", component: <Home04 />},
    { path: "home02", component: <Home02 />},
    { path: "home03", component: <Home03 />},
    { path: "home04", component: <Home01 />},
]

export default routes;